import { z } from "zod";

export const createWarehouseEntrySchema = z.object({
  documentNumber: z.string(),
  supplierName: z.string(),
  origin: z.string(),
  purchaseDate: z.date(),
  purchasePrice: z.string(),
  note: z.string().optional(),
  quantity: z.string(),
});

export type CreateWarehouseEntry = z.infer<typeof createWarehouseEntrySchema>;
